
import React, { useEffect, useState } from "react";
import PocketBase from "pocketbase";
import { IoMdCall } from "react-icons/io";
import { FaWhatsapp } from "react-icons/fa";

const HotelStars = ({ rating }) => {
  const maxStars = 5;
  const stars = [];
  for (let i = 1; i <= maxStars; i++) {
    stars.push(
      <span key={i} className={i <= rating ? "text-yellow-600" : "text-gray-300"}>
        &#9733;
      </span>
    );
  }
  return <div className="text-sm">{stars}</div>;
};

const pb = new PocketBase(process.env.REACT_APP_POCKETBASE_URL);

const RoomBooking = () => {
  const [hotels, setHotels] = useState([]);
  const [selectedCity, setSelectedCity] = useState("all");
  const [selectedGuests, setSelectedGuests] = useState("1");
  const [citys, setCitys] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const hotelsResult = await pb.collection("Hotels").getFullList();
        const citiesResult = await pb.collection("Citys").getFullList();

        setHotels(hotelsResult);
        setCitys(citiesResult);
      } catch (error) {
        console.error("Error fetching hotel data:", error);
      }
    }
    fetchData();
  }, []);

  const handleCallClick = (hotel) => {
    if (hotel.contact) {
      window.location.href = `tel:${hotel.contact}`;
    } else {
      console.error("No contact number available for", hotel.name);
    }
  };

  const handleWhatsAppClick = (hotel) => {
    const message = `Hi, I'm interested in the room at ${hotel.name}. Price starting from ${hotel.price ? `RsH ${hotel.price}.00` : "Price Unavailable"}. Please send me further details.`;
    const whatsappUrl = `https://wa.me/+94${hotel.whatsapp}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  };

  const filteredHotels = hotels.filter((hotel) => {
    const matchesCity = selectedCity === "all" || hotel.city === selectedCity;
    const matchesGuests = hotel.gust ? (parseInt(selectedGuests) <= hotel.gust) : true;
    return matchesCity && matchesGuests;
  });

  return (
    <div className="p-6 space-y-6 max-w-6xl mx-auto">
      <div className="flex flex-col lg:flex-row md:flex-col gap-6">
        <aside className="lg:w-1/2 space-y-4 border p-4 rounded-lg">
          <div>
            <label className="block font-medium mb-1">City</label>
            <select
              className="w-full border p-2 rounded"
              value={selectedCity}
              onChange={(e) => setSelectedCity(e.target.value)}
            >
              <option value="all">All Cities</option>
              {citys.map((city) => (
                <option key={city.id} value={city.id}>
                  {city.name}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block font-medium mb-1">Guests</label>
            <select
              className="w-full border p-2 rounded"
              value={selectedGuests}
              onChange={(e) => setSelectedGuests(e.target.value)}
            >
              <option>1</option>
              <option>2</option>
              <option>3</option>
              <option>4</option>
            </select>
          </div>
        </aside>

        <div className="w-full space-y-4">
          {filteredHotels.length > 0 ? (
            filteredHotels.map((hotel) => (
              <div
                key={hotel.id}
                className="flex items-center justify-between p-4 border rounded-lg shadow-sm"
              >
                <div className="flex items-center">
                  <img
                    src={`${process.env.REACT_APP_POCKETBASE_URL}/api/files/${hotel.collectionId}/${hotel.id}/${hotel.image}`}
                    alt={hotel.name}
                    className="w-28 h-20 object-cover rounded mr-4"
                  />
                  <div>
                    <h2 className="font-semibold text-lg">{hotel.name}</h2>
                    <HotelStars rating={hotel.rating || 0} />
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-sm">Starting From</p>
                  <p className="font-bold text-lg">
                    {hotel.price ? `RsH ${hotel.price}.00` : "Price Unavailable"}
                  </p>
                  {hotel.reviewScore && (
                    <p className="text-xs text-gray-500 mt-1">
                      {hotel.reviewScore}/10 Fine
                    </p>
                  )}
                  {!hotel.reviewScore && (
                    <p className="text-xs text-gray-500 mt-1">
                      No reviews
                    </p>
                  )}
                  <div className="flex gap-2 justify-end pt-4">
                    <button 
                      onClick={() => handleCallClick(hotel)}
                      className="flex items-center px-2 py-1 lg:px-3 lg:py-2 bg-blue-600 text-white text-sm rounded"
                    >
                      <IoMdCall className="mr-1" />
                      Call
                    </button>
                    <button 
                      onClick={() => handleWhatsAppClick(hotel)}
                      className="flex items-center px-2 py-1 lg:px-3 lg:py-2 bg-green-600 text-white text-sm rounded"
                    >
                      <FaWhatsapp className="mr-1" />
                      WhatsApp
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>No Rooms available at the moment.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default RoomBooking;
